'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:DirectorCtrl
 * @description
 * # DirectorCtrl
 * Controller of the cimerFrontEndApp
 */

angular.module('cimerFrontEndApp')
  .controller('UploadDirectorCtrl', ['$scope', '$http', '$location', 'Session', 'Upload', 'ApiUrl', 'ReportService', '$timeout', function ($scope, $http, $location, Session, Upload, ApiUrl, ReportService, $timeout) {

      var sessionObject = Session.getSessionObject();
      if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
          $location.url('/');
          return;
      }

      $scope.UploadResults = [];
      $scope.Project = null;
      $scope.Division = null;

      $http.get(ApiUrl.url('/Project/') + 'GetProjectsWhereUserIsAdmin')
          .then(function (response) {
              $scope.projects = response.data;
          });

      $scope.getDivisions = function (project) {
          $http.get(ApiUrl.url('/Division/') + 'Divisions/' + project.ProjectId)
              .then(function (response) {
                  $scope.divisions = response.data;
              });
      };

      $scope.selectProject = function() {
          if (!$scope.Project) {
              $scope.divisions = [];
          }
          else {
              $scope.getDivisions($scope.Project);
          }
      };

      $scope.Saving = true;
      //Upload stuff
      var _apiUrl = ApiUrl.url('/Upload/');

      $http.get(_apiUrl + 'UserRelationshipOptions')
          .then(function (response) {
              $scope.UserRelationshipOptions = response.data;
              $scope.Saving = false;
          });

      $scope.DirectorUploadFileTypes = ['.txt', '.csv'];
      $scope.DirectorUploadFileTypesList = $scope.DirectorUploadFileTypes.join(',');
      $scope.clearUpload;
      $scope.CacheKey = null;
      $scope.Saving = false;
      $scope.manualInput = {
          eventTitle: '',
          startDate: null,
          email: '',
          alternateEmail: ''
      };

      $scope.UploadFunction = function ($file) {
          $scope.ErrorMessage = "";
          $scope.Saving = true;
          $scope.formSubmitted = true;
          Upload.upload({
              url: _apiUrl + 'UploadDirectors',
              file: $file
          }).then(function (response) {
              $scope.Saving = false;
              if (response) {
                  //Success
                  $scope.Cachekey = response.data.Cachekey;
                  $scope.Directors = response.data.Directors;
              } else {
                  $scope.ErrorMessage = "Please check the format of uploaded file";
              }
          }, function (err) {
              $location.path('error');
          });
      };

      $scope.CancelUpload = function () {
          var data = {
              Cachekey: $scope.Cachekey
          };

          $http.post(_apiUrl + 'AbortDirectorUpload', data).then(function (response) {
              $scope.Cachekey = null;
              $scope.Directors = null;
              $scope.clearUpload = true;
          }, function (err) {
              $location.path('error');
          });

      };

      $scope.SubmitUpload = function () {
          $scope.formSubmitted = true;

          if (!this.uploadForm.$valid || !$scope.Division) {
              return;
          }
          $scope.Saving = true;
          var data = {
              Cachekey: $scope.Cachekey,
              DivisionID: $scope.Division.DivisionID
          };

          $http.post(_apiUrl + 'CommitDirectorUpload', data).then(function (response) {
              if (response.data) {
                  $scope.Saving = false;
                  $scope.Cachekey = null;
                  $scope.Directors = null;
                  $scope.clearUpload = true;
                  $scope.successMessage();
              }
          }, function (err) {
              $location.path('error');
          });
      };

      $scope.manualUserAdd = function () {
          $scope.formSubmitted = true;

          if (!this.manualForm.$valid || !$scope.Division) {
              return;
          }
          $scope.Saving = true;
          var data = {
              Email: $scope.manualInput.email,
              AlternateEmail: $scope.manualInput.alternateEmail,
              Grant: {
                  Name: $scope.manualInput.eventTitle,
                  StartDate: $scope.manualInput.startDate,
                  DivisionID: $scope.Division.DivisionID
              }
          };

          $http.post(_apiUrl + 'ManualSaveDirectors', data).then(function (response) {
              if (response.data) {
                  $scope.Saving = false;                  
                  $scope.clearManualUserAdd();
                  $scope.successMessage();
              }
          }, function (err) {
              $location.path('error');
          });
      };

      $scope.clearManualUserAdd = function () {
          $scope.manualInput = {
              eventTitle: '',
              startDate: null,
              email: '',
              alternateEmail: ''
          };
          $scope.formSubmitted = false;
      };

      $scope.successMessage = function () {
          $scope.uploadMessage = 'Event(s) successfully created';
          $timeout(function () {
              $scope.uploadMessage = '';
          }, 5000);
      };
  }]);
